import React, {useState} from 'react';
import {FaArrowAltCircleUp} from 'react-icons/fa';
import { window } from 'browser-monads'
  
const ScrollButton = () =>{
  
  const [visible, setVisible] = useState(false)
  
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300){
      setVisible(true)
    } 
    else if (scrolled <= 300){
      setVisible(false)
    }
  };
  
  const scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };
  
  window.addEventListener('scroll', toggleVisible);
  
  return (
    <div className="AnyClassForContainer AnyClassForTransition">
        {visible && <button className="btn" title="Back to Top" onClick={scrollToTop}><FaArrowAltCircleUp size={40} color="rgb(62, 75, 177)"/></button>}
    </div>
  );
}
  
export default ScrollButton;